import { CurrencyInput, NumberInput, TextInput } from '@framework/form';
import { Alert } from 'antd';
import React from 'react';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem';
import { IWidgetParsedProps } from '../../../inputs/common/util/getWidgetProps';
import {
  getPaymentRowKey,
  PaymentRowFieldKey,
} from '../createPaymentRowFormSchema';
import { PaymentRowWidgetFieldConfig } from '../IPaymentRowWidget';
import { PaymentRowLogic } from '../PaymentRowLogic';
import { ComputedNumberPaymentRowField } from './computed/ComputedNumberPaymentRowField';
import { ComputedStringPaymentRowField } from './computed/ComputedStringPaymentRowField';

export interface IPaymentRowFieldInputProps {
  name: string;
  field: PaymentRowFieldKey;
  config: PaymentRowWidgetFieldConfig;
  label: string;
  help?: string;
  type: 'number' | 'string' | 'currency' | 'percentage';
  options: IWidgetParsedProps;
}

const formatCurrency = (value: number | null) =>
  PaymentRowLogic.formatCurrency(value);
const formatPercentage = (value: number | null) =>
  value != null ? `${value}%` : '-%';

export function PaymentRowFieldInput(props: IPaymentRowFieldInputProps) {
  const { config, label, help, type, options } = props;

  const { readonly } = options;

  const fieldName = getPaymentRowKey(options.name, props.field);

  // Se il campo non è editabile, va renderizzato come un campo calcolato
  if (!config.editable) {
    if (type === 'number' || type === 'currency' || type === 'percentage') {
      return (
        <ComputedNumberPaymentRowField
          name={fieldName}
          label={label}
          help={help}
          readonly={readonly}
          expression={config.expression}
          format={
            type === 'currency'
              ? formatCurrency
              : type === 'percentage'
              ? formatPercentage
              : undefined
          }
        />
      );
    }

    if (type === 'string') {
      return (
        <ComputedStringPaymentRowField
          name={fieldName}
          label={label}
          help={help}
          readonly={readonly}
          expression={config.expression}
        />
      );
    }
  }

  if (type === 'number' || type === 'percentage') {
    return (
      <ConfigFormItem
        name={fieldName}
        label={label}
        help={help}
        readonly={readonly}
      >
        <NumberInput
          readOnly={readonly}
          name={fieldName}
          step={1}
          suffix={type === 'percentage' ? '%' : undefined}
          value={options.value as any}
        />
      </ConfigFormItem>
    );
  }

  if (type === 'currency') {
    return (
      <ConfigFormItem
        name={fieldName}
        label={label}
        help={help}
        readonly={readonly}
      >
        <CurrencyInput
          readOnly={readonly}
          name={fieldName}
          value={options.value}
          tabIndex={options.preview ? -1 : undefined}
        />
      </ConfigFormItem>
    );
  }

  if (type === 'string') {
    return (
      <ConfigFormItem
        name={fieldName}
        label={label}
        help={help}
        readonly={readonly}
      >
        <TextInput
          name={fieldName}
          value={options.value as any}
          tabIndex={options.preview ? -1 : undefined}
          readOnly={readonly}
        />
      </ConfigFormItem>
    );
  }

  return <Alert message="Tipo di campo non supportato" type="error" showIcon />;
}
